import { AboutUs1 } from "../components/AboutUsPage/AboutUs1";
import { AboutUs2 } from "../components/AboutUsPage/AboutUs2";
import { AboutUs3 } from "../components/AboutUsPage/AboutUs3";

export const AboutUs = () => {
    return (
        <>
        <AboutUs1 />
        <AboutUs2 />
        <AboutUs3 />
        </>
    );
}